export default __webpack_public_path__ + "static/media/testing-frequency-icon.ca2ac064.svg";